export const PAYER_LOAN_OFFICER = "loanOfficer"
export const PAYER_BORROWER = "borrower"

export function formatMoney(value) {
    const n = Number(value)
    if (!(n > 0)) return null
    return `$${n.toFixed(2)}`
}

export function formatTriMergePricing(account) {
    const individual = formatMoney(account?.IndividualTriMergePrice)
    const joint = formatMoney(account?.JointTriMergePrice)
    if (!individual || !joint) return null
    return `${individual} individual · ${joint} joint`
}

export function hasTriMergePricing(account) {
    return Number(account?.IndividualTriMergePrice) > 0 && Number(account?.JointTriMergePrice) > 0
}

export function normalizeBorrowerPaidPolicy(policy) {
    return {
        Enabled: Boolean(policy?.Enabled),
        DefaultPayer: policy?.DefaultPayer === PAYER_BORROWER ? PAYER_BORROWER : PAYER_LOAN_OFFICER,
        AllowLoOverride: Boolean(policy?.AllowLoOverride),
    }
}

export function effectiveHardPullPayer(policy, preference) {
    const normalized = normalizeBorrowerPaidPolicy(policy)
    if (!normalized.Enabled) {
        return PAYER_LOAN_OFFICER
    }
    if (normalized.AllowLoOverride && preference?.HardPullPayer) {
        return preference.HardPullPayer === PAYER_BORROWER ? PAYER_BORROWER : PAYER_LOAN_OFFICER
    }
    return normalized.DefaultPayer
}
